import { useAuth } from '../../hooks';
import { useEffect } from 'react';

export default function Impersonate() {
  const { accessToken, onUpdate, setImpersonationToken } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.slice(1));
    const token = params.get('token');

    if (token) {
      const originalAccessToken = localStorage.getItem('accessToken');
      const refreshToken = localStorage.getItem('refreshToken');

      localStorage.clear();

      if (originalAccessToken)
        localStorage.setItem('accessToken', originalAccessToken);
      if (refreshToken) localStorage.setItem('refreshToken', refreshToken);

      if (!accessToken) {
        onUpdate({ accessToken: token });
      }
      setImpersonationToken(token);
    }
    window.location.href = '/';
  }, []);

  return null;
}
